// BEGIN: popup-shipping-insurance.js

document.addEventListener('DOMContentLoaded', function() {
  // 1. Grab references to checkout and popup elements
  const originalCheckoutButton = document.querySelector('#custom-cart-checkout');

  const popupOverlay          = document.getElementById('popup-overlay');
  const popupTitle            = document.getElementById('popup-title'); // optional title
  const insuranceText         = document.getElementById('insurance-text');
  const signatureText         = document.getElementById('signature-text');
  const proceedCheckoutButton = document.getElementById('proceed-checkout-button');
  const closePopupButton      = document.getElementById('close-popup-button');
  const extraInsuranceNote    = document.getElementById('extra-insurance-note');
  const extraSignatureNote    = document.getElementById('extra-signature-note');

  // NEW: Instead of "Add" buttons, we have checkboxes for Insurance & Signature
  const insuranceCheckbox     = document.getElementById('insurance-checkbox');
  const signatureCheckbox     = document.getElementById('signature-checkbox');

  // "Remove Signature" button from your HTML (if you still have it somewhere)
  const removeSignatureButton = document.getElementById('remove-signature-button');

  // 2. Variant IDs (replace these with your real IDs)
  const SHIPPING_INSURANCE_VARIANT_ID = 40306027724949; 
  const SIGNATURE_VARIANT_ID          = 42642778652821; 

  // 3. Intercept original cart checkout button => show popup
  if (originalCheckoutButton) {
    originalCheckoutButton.addEventListener('click', function(event) {
      event.preventDefault();
      showPopup();
    });
  }

  // -------------------------------------------
  // SHOW POPUP
  // -------------------------------------------
  function showPopup() {
    const insuranceWrapper = document.getElementById('insurance-wrapper');
    const insuranceCheckbox = document.getElementById('insurance-checkbox');
    const insuranceText = document.getElementById('insurance-text');
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartTotal    = cart.total_price / 100.0;
        const insuranceQty = calculateInsuranceQty(cartTotal);

        // Hide entire insurance UI if insuranceQty=0
        if (insuranceQty === 0) {
          if (insuranceWrapper) insuranceWrapper.style.display = 'none';
          if (insuranceText) insuranceText.style.display = 'none';
          if (insuranceCheckbox) insuranceCheckbox.style.display = 'none';
          if (popupTitle) popupTitle.textContent = "Would you like to add a Delivery Signature option?";
          
          // Hide the extra-insurance-note
          if (extraInsuranceNote) {
            extraInsuranceNote.style.display = 'block';
            extraInsuranceNote.style.color = '#000';
            extraInsuranceNote.innerHTML = `
              <div>
                <ul style="list-style: none; margin: 0; padding: 0; padding: 0; text-align: left;"">
                  <li style="margin-bottom: 1em; display: flex;">
                    <span style="color: #00ad00; font-size: 20px; font-weight: bold; margin-right: 10px;">&#10003;</span>
                    <div>
                      <span style="font-weight: 600">Extra security</span> ensuring peace of mind.
                    </div>
                  </li>
                  <li style="margin-bottom: 1em; display: flex;">
                    <span style="color: #00ad00; font-size: 20px; font-weight: bold; margin-right: 10px;">&#10003;</span>
                    <div>
                      <span style="font-weight: 600">Signature option</span> adds an extra layer of protection against 'Porch Pirates'.
                    </div>
                  </li>
                </ul>
              </div>
            `;
          }
        } else {
          // Show shipping insurance UI
          if (insuranceText)     insuranceText.style.display    = 'block';
          if (insuranceCheckbox) insuranceCheckbox.style.display = 'inline-block';
          if (popupTitle) popupTitle.textContent = "Would you like to add additional Shipping Insurance or a Delivery Signature option?";
          
          // Show insurance cost
          const insuranceUnitPrice = 3.00;
          const insuranceTotal     = insuranceUnitPrice * insuranceQty;
          if (insuranceText) {
            insuranceText.textContent = `Shipping Insurance: $${insuranceTotal.toFixed(2)}`;
          }

          // Default note text if not added (just an example)
          if (extraInsuranceNote) {
            extraInsuranceNote.style.display = 'block';
            extraInsuranceNote.style.color = '#000';
            extraInsuranceNote.innerHTML = `
              <div>
                <ul style="list-style: none; margin: 0; padding: 0; text-align: left;">
                  <li style="margin-bottom: 1em; display: flex;">
                    <span style="color: #00ad00; font-size: 20px; font-weight: bold; margin-right: 10px;">&#10003;</span>
                    <div>
                      <span style="font-weight: 600">Extra security</span> ensuring peace of mind.
                    </div>
                  </li>
                  <li style="margin-bottom: 1em; display: flex;">
                    <span style="color: #00ad00; font-size: 20px; font-weight: bold; margin-right: 10px;">&#10003;</span>
                    <div>
                      <span style="font-weight: 600">Affordable coverage</span> at $3 per additional $100 of coverage above the initial $100.
                    </div>
                  </li>
                  <li style="margin-bottom: 1em; display: flex;">
                    <span style="color: #00ad00; font-size: 20px; font-weight: bold; margin-right: 10px;">&#10003;</span>
                    <div>
                      <span style="font-weight: 600">Worry-free shopping</span> knowing your order is covered for loss or damage during transit.
                    </div>
                  </li>
                  <li style="margin-bottom: 1em; display: flex;">
                    <span style="color: #00ad00; font-size: 20px; font-weight: bold; margin-right: 10px;">&#10003;</span>
                    <div>
                      <span style="font-weight: 600">Signature option</span> adds an extra layer of protection against 'Porch Pirates'.
                    </div>
                  </li>
                </ul>

                <p style="color: #dc3545; font-size: 11px; font-weight: 500; line-height: 16px; margin-top: 20px;">
                  <span style="font-weight: 700;">Important:</span> Canada Post Expedited Parcel and Xpresspost shipments within Canada include up to $100 in coverage for loss or damage during transit, subject to Canada Post’s terms and exclusions. 
                </p>
              </div>
            `;
          }
        }

        // Check if insurance already in cart => checkbox checked
        const insuranceItem = cart.items.find(
          item => item.variant_id === SHIPPING_INSURANCE_VARIANT_ID
        );
        if (insuranceItem && insuranceCheckbox) {
          insuranceCheckbox.checked = true;
          // Optionally tweak note color if item is in cart
          if (extraInsuranceNote) {
            extraInsuranceNote.style.color   = '#000';
            extraInsuranceNote.innerHTML = `
              <span style="color: #00ad00; font-size: 20px; font-weight: bold; margin-right: 10px;">&#10003;</span>
              <span>Your order is insured for any loss or damages incurred during transit.</span>
              <p style="font-size: 12px; color: #dc3545; font-weight: 500;">
                Your shipping insurance may have been adjusted to match your cart total.
              </p>
            `;
          }
        } else if (insuranceQty > 0 && insuranceCheckbox) {
          insuranceCheckbox.checked = false;
        }

        // Check if signature already in cart => checkbox checked
        const signatureItem = cart.items.find(
          item => item.variant_id === SIGNATURE_VARIANT_ID
        );
        if (signatureItem && signatureCheckbox) {
          signatureCheckbox.checked = true;
          // Show signature note
          if (extraSignatureNote) {
            extraSignatureNote.style.display = 'block';
            extraSignatureNote.innerHTML = '<span style="font-weight: bold;">Notice</span>: Please ensure someone will be home to sign when your order arrives.';
          }
        } else if (signatureCheckbox) {
          signatureCheckbox.checked = false;
          // Hide signature note if not in cart
          if (extraSignatureNote) extraSignatureNote.style.display = 'none';
        }

        // Show popup overlay
        document.body.style.overflow = 'hidden';
        if (popupOverlay) popupOverlay.style.display = 'flex';
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  // -------------------------------------------
  // PROCEED TO CHECKOUT
  // -------------------------------------------
  // SAFETY CHECK: Only add the listener if proceedCheckoutButton exists:
  if (proceedCheckoutButton) {
    proceedCheckoutButton.addEventListener('click', async () => {
      console.log("DEBUG: 'Proceed to Checkout' clicked in popup...");

      // 1) Fetch the current cart
      const cart = await fetch('/cart.js').then(r => r.json());

      // ----------------------------------------------------------------
      // INSURANCE LOGIC with the CHECKBOX
      // ----------------------------------------------------------------
      const insuranceItem = cart.items.find(
        item => item.variant_id === SHIPPING_INSURANCE_VARIANT_ID
      );

      // We'll calculate insuranceQty if the user wants it
      const cartTotal = cart.total_price / 100.0;
      let newInsuranceQty = 0;
      if (insuranceCheckbox && insuranceCheckbox.checked) {
        newInsuranceQty = calculateInsuranceQty(cartTotal);
      }

      if (insuranceItem) {
        // If item is in cart but user UNchecked => remove
        if (insuranceCheckbox && !insuranceCheckbox.checked) {
          console.log("DEBUG: user unchecked insurance => remove from cart");
          await removeInsuranceLineItems(cart, SHIPPING_INSURANCE_VARIANT_ID);
        } else {
          // If user checked => remove old lines, re-add with correct tier
          await removeInsuranceLineItems(cart, SHIPPING_INSURANCE_VARIANT_ID);
          if (newInsuranceQty > 0) {
            await addToCart(SHIPPING_INSURANCE_VARIANT_ID, newInsuranceQty);
          }
        }
      } else {
        // If item not in cart but user CHECKED => add
        if (insuranceCheckbox && insuranceCheckbox.checked && newInsuranceQty > 0) {
          console.log("DEBUG: user checked insurance => add it with qty=" + newInsuranceQty);
          await addToCart(SHIPPING_INSURANCE_VARIANT_ID, newInsuranceQty);
        }
      }

      // ----------------------------------------------------------------
      // SIGNATURE LOGIC with the CHECKBOX
      // ----------------------------------------------------------------
      const signatureItem = cart.items.find(
        item => item.variant_id === SIGNATURE_VARIANT_ID
      );

      // If user checks signature => add if not in cart
      // If user unchecks => remove if in cart
      if (signatureItem) {
        if (signatureCheckbox && !signatureCheckbox.checked) {
          console.log("DEBUG: user unchecked signature => remove from cart");
          await removeSignatureLineItems(cart, SIGNATURE_VARIANT_ID);
        } else {
          console.log("DEBUG: user left signature checked => keep it in cart");
        }
      } else {
        if (signatureCheckbox && signatureCheckbox.checked) {
          console.log("DEBUG: user checked signature => add it to cart");
          await addToCart(SIGNATURE_VARIANT_ID, 1);
        }
      }

      // 2) Finally, go to checkout
      console.log("DEBUG: Going to checkout now...");
      document.getElementById('cart-checkout').click();
    });
  }

  // -------------------------------------------
  // CLOSE POPUP => REFRESH or "Continue Shopping" 
  // -------------------------------------------
  // SAFETY CHECK: Only add the listener if closePopupButton exists:
  if (closePopupButton) {
    closePopupButton.addEventListener('click', async () => {
      console.log("DEBUG: 'Continue Shopping' clicked in popup...");

      // If we want to also apply the same add/remove logic on "Continue Shopping," do it now:
      const cart = await fetch('/cart.js').then(r => r.json());

      // INSURANCE
      const insuranceItem = cart.items.find(
        item => item.variant_id === SHIPPING_INSURANCE_VARIANT_ID
      );
      const cartTotal = cart.total_price / 100.0;
      let newInsuranceQty = 0;
      if (insuranceCheckbox && insuranceCheckbox.checked) {
        newInsuranceQty = calculateInsuranceQty(cartTotal);
      }

      if (insuranceItem) {
        // If user unchecked => remove
        if (insuranceCheckbox && !insuranceCheckbox.checked) {
          await removeInsuranceLineItems(cart, SHIPPING_INSURANCE_VARIANT_ID);
        } else {
          // re-check tier if needed
          await removeInsuranceLineItems(cart, SHIPPING_INSURANCE_VARIANT_ID);
          if (newInsuranceQty > 0) {
            await addToCart(SHIPPING_INSURANCE_VARIANT_ID, newInsuranceQty);
          }
        }
      } else {
        // if not in cart but checked => add
        if (insuranceCheckbox && insuranceCheckbox.checked && newInsuranceQty > 0) {
          await addToCart(SHIPPING_INSURANCE_VARIANT_ID, newInsuranceQty);
        }
      }

      // SIGNATURE
      const signatureItem = cart.items.find(
        item => item.variant_id === SIGNATURE_VARIANT_ID
      );
      if (signatureItem) {
        if (signatureCheckbox && !signatureCheckbox.checked) {
          await removeSignatureLineItems(cart, SIGNATURE_VARIANT_ID);
        }
      } else {
        if (signatureCheckbox && signatureCheckbox.checked) {
          await addToCart(SIGNATURE_VARIANT_ID, 1);
        }
      }

      // Hide overlay
      if (popupOverlay) popupOverlay.style.display = 'none';
      // Refresh page
      window.location.reload();
    });
  }

  // -------------------------------------------
  // REMOVE SIGNATURE BUTTON - If still needed
  // -------------------------------------------
  // SAFETY CHECK: Only add the listener if removeSignatureButton exists:
  if (removeSignatureButton) {
    removeSignatureButton.addEventListener('click', function() {
      // 1. Fetch the current cart
      fetch('/cart.js')
        .then(response => response.json())
        .then(async cart => {
          // 2. Call removeSignatureLineItems
          await removeSignatureLineItems(cart, SIGNATURE_VARIANT_ID);

          // 3. Refresh to see updated cart
          window.location.reload();
        })
        .catch(err => {
          console.error('Error removing signature:', err);
        });
    });
  }

  // -------------------------------------------
  // HELPER FUNCTIONS
  // -------------------------------------------

  // (A) Insurance Calculation
  function calculateInsuranceQty(cartTotal) {
    if (cartTotal <= 100)  return 0;
    if (cartTotal <= 200)  return 1;
    if (cartTotal <= 300)  return 2;
    if (cartTotal <= 400)  return 3;
    if (cartTotal <= 500)  return 4;
    if (cartTotal <= 600)  return 5;
    if (cartTotal <= 700)  return 6;
    if (cartTotal <= 800)  return 7;
    if (cartTotal <= 900)  return 8;
    if (cartTotal <= 1000) return 9;
    if (cartTotal <= 1100) return 10;
    if (cartTotal <= 1200) return 11;
    if (cartTotal <= 1300) return 12;
    if (cartTotal <= 1400) return 13;
    if (cartTotal <= 1500) return 14;
    if (cartTotal <= 1600) return 15;
    if (cartTotal <= 1700) return 16;
    if (cartTotal <= 1800) return 17;
    if (cartTotal <= 1900) return 18;
    if (cartTotal <= 2000) return 19;
    if (cartTotal <= 2100) return 20;
    if (cartTotal <= 2200) return 21;
    if (cartTotal <= 2300) return 22;
    if (cartTotal <= 2400) return 23;
    if (cartTotal <= 2500) return 24;
    if (cartTotal <= 2600) return 25;
    if (cartTotal <= 2700) return 26;
    if (cartTotal <= 2800) return 27;
    if (cartTotal <= 2900) return 28;
    if (cartTotal <= 3000) return 29;
    if (cartTotal <= 3100) return 30;
    if (cartTotal <= 3200) return 31;
    if (cartTotal <= 3300) return 32;
    if (cartTotal <= 3400) return 33;
    if (cartTotal <= 3500) return 34;
    if (cartTotal <= 3600) return 35;
    if (cartTotal <= 3700) return 36;
    if (cartTotal <= 3800) return 37;
    if (cartTotal <= 3900) return 38;
    if (cartTotal <= 4000) return 39;
    if (cartTotal <= 4100) return 40;
    if (cartTotal <= 4200) return 41;
    if (cartTotal <= 4300) return 42;
    if (cartTotal <= 4400) return 43;
    if (cartTotal <= 4500) return 44;
    if (cartTotal <= 4600) return 45;
    if (cartTotal <= 4700) return 46;
    if (cartTotal <= 4800) return 47;
    if (cartTotal <= 4900) return 48;
    if (cartTotal <= 5000) return 49;
    return 50; // Anything above 5000 => 50 (change if you want a different cap)
  }

  // (B) Add to Cart
  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(response => response.json());
  }

  // (C) Remove Insurance Items
  async function removeInsuranceLineItems(cart, variantId) {
    const lineItemsToRemove = cart.items.filter(item => item.variant_id === variantId);
    for (const insuranceItem of lineItemsToRemove) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: insuranceItem.key,
          quantity: 0
        })
      });
    }
  }

  // (D) Remove Signature Items - NEW!
  async function removeSignatureLineItems(cart, variantId) {
    const lineItemsToRemove = cart.items.filter(item => item.variant_id === variantId);
    for (const signatureItem of lineItemsToRemove) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: signatureItem.key, // line item key
          quantity: 0            // set to zero to remove
        })
      });
    }
  }

});
// END: popup-shipping-insurance.js
